// The default font family used across the application.
export const fontFamily = "Inter, Helvetica, Arial, sans-serif";
